(function(){
    'use strict'

    angular.module('app.feriados')
    .factory('FeriadosService', FeriadosService);

    FeriadosService.$inject = ['$http', '$q', 'apiSettings'];

    function FeriadosService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/feriados';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(feriadoId){

            var url = apiSettings.apiBaseUrl + 'api/feriados/' + feriadoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(feriado){

            feriado.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/feriados',  
                method: 'POST',  
                data: feriado
            });  
            return response;
        };

        function update(feriado){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/feriados',  
                method: 'PUT',  
                data: feriado
            });  
            return response;
        };

        function remove(feriado){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/feriados',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: feriado
            });  
            return response;
        };

    };

})();